import React from 'react'
import img1 from '../../assets/img/ShreegitaWHyChooseUs.png';
import ProductExpertise from '../../assets/img/icons/ProductExpertise.svg';
import GlobalReachwithLocalInsight  from '../../assets/img/icons/GlobalReachwithLocalInsight.svg';

const WhyUs = () => {
  return (
    <section className="why-choice-us  " style={{
        padding:"38px 0px"
    }}>
        <div className="why-choice-bg bg-cover d-none d-xl-block" style={{backgroundImage: `url(${img1})`}}></div>
        <div className="container">
            <div className="row">
                <div className="offset-xl-6 offset-lg-4 col-lg-8 col-xl-6 col-12">
                    <div className="block-contents">
                        <div className="section-title">
                            <span>Why Choose Us</span>
                            <h2>Your Trusted Partner in Excellence</h2>
                        </div>
                    </div>
                    <div className="single-icon-circle-item">
                        <div className="icon">
                            {/* <i className="flaticon-cpu"></i> */}
                            <img src={ProductExpertise} alt="Product Expertise" style={{
                                position: 'absolute',
                                top:"23px",
                                left: "23px",
                              
                            }} />
                        </div>
                        <div className="contents">
                            <h3>  Product Expertise   </h3>
                            <p>From sourcing and production to refining and distribution, we offer a full spectrum of high-quality raw and processed materials to meet diverse industry needs. .</p>
                        </div>
                    </div>
                    <div className="single-icon-circle-item">
                        <div className="icon">
                        <img src={GlobalReachwithLocalInsight} alt="Product Expertise" style={{
                                position: 'absolute',
                                top:"23px",
                                left: "23px",
                              
                            }} />
                        </div>
                        <div className="contents">
                            <h3>Global Reach with Local Insight </h3>
                            <p>Our extensive market knowledge and global presence ensure tailored solutions that address the specific demands of both large corporations and local businesses.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}

export default WhyUs